import { HttpClient } from '@angular/common/http';
import { UxService } from '~/app/core/services';
import { GenericApi } from '~/app/open-age/core/services';
import { environment } from '../../../../environments/environment';
import { RoleService } from '../../core/services';

export class DirectoryApi<TModel> extends GenericApi<TModel> {
  constructor(
    collection: string,
    http: HttpClient,
    auth: RoleService,
    uxService: UxService
  ) {
    super(http, 'directory', { collection, auth, errorHandler: uxService });
  }
}
